// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReDate from "@mobily/rescript-date/src/ReDate.bs.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as App_Types_Date$DvmAdminFrontendFr from "../../../../common/types/App_Types_Date.bs.js";

function nonfleetPARCDatesEditable(order, lookAtExit) {
  var match = Belt_Option.getWithDefault(order.header.orderOrderType, /* NOTSET */16);
  if (!(match > 15 || match < 1) && match !== 11) {
    return Belt_List.length(Belt_List.keep(Belt_List.keepMap(Belt_List.keep(Belt_Option.getWithDefault(order.bonuses, /* [] */0), (function (x) {
                              if (lookAtExit) {
                                return Belt_Option.getWithDefault(x.actionIsPARCExit, false);
                              } else {
                                return true;
                              }
                            })), (function (x) {
                          return x.resultActionStatus;
                        })), (function (x) {
                      if (x === /* PAID */4 || x === /* PREINVOICED */5) {
                        return true;
                      } else {
                        return x === /* NOBONUS */3;
                      }
                    }))) === 0;
  } else {
    return true;
  }
}

function orderDeliveredForSevenDays(order) {
  return Belt_Option.mapWithDefault(order.body.resultDeliveryDate, false, (function (date) {
                return ReDate.differenceInCalendarDays(ReDate.startOfDay(new Date()), date) > 7;
              }));
}

function fillForm(order, newestUndeployedCorrection) {
  var match = Belt_Option.mapWithDefault(newestUndeployedCorrection, [
        order.body.orderSiret,
        order.body.orderSirenFinalCustomer,
        Belt_Option.flatMap(order.budgetBonus, (function (x) {
                return x.orderCompanyDiscount;
              })),
        order.body.orderAcquisitionType,
        Belt_Option.flatMap(order.budgetBonus, (function (x) {
                return x.orderBudgetType;
              })),
        order.body.orderRegistrationDate,
        order.body.orderRegistrationId,
        order.body.orderCustomerInvoiceDate,
        order.body.orderCustomerInvoiceNumber,
        order.header.orderOrderType,
        order.body.orderCustomerDiscount,
        order.body.orderEasyPack,
        order.body.orderCustomerName,
        order.body.orderCustomerFirstName,
        order.body.resultCalcPARCStartDate,
        order.body.resultPARCEndDate,
        order.body.orderOrderDate,
        order.body.orderRenaultInvoiceDate,
        order.body.orderMADADate,
        order.body.orderMADCDate
      ], (function (x) {
          return [
                  x.siret,
                  x.sirenFinalCustomerLLD,
                  x.companyDiscountPercentage,
                  x.acquisitionType,
                  x.budgetType,
                  x.newCarRegistrationDate,
                  x.newCarRegistrationID,
                  x.customerInvoiceDate,
                  x.customerInvoiceNumber,
                  x.orderType,
                  x.customerDiscount,
                  x.easyPack,
                  x.shortCustomerName,
                  x.customerFirstName,
                  x.parcStartDate,
                  x.parcEndDate,
                  x.orderDate,
                  x.renaultInvoiceDate,
                  x.carSaleAvailibilityDateMADA,
                  x.carSaleAvailibilityDateMADC
                ];
        }));
  return {
          siret: Belt_Option.getWithDefault(match[0], ""),
          finalCustomer: Belt_Option.getWithDefault(match[1], ""),
          discount: Belt_Option.mapWithDefault(match[2], "", (function (x) {
                  return String(x);
                })),
          acquisitionType: Belt_Option.getWithDefault(match[3], ""),
          budget: Belt_Option.getWithDefault(match[4], ""),
          registrationDate: match[5],
          registrationNumber: Belt_Option.getWithDefault(match[6], ""),
          invoiceClient: match[7],
          invoiceNumber: Belt_Option.getWithDefault(match[8], ""),
          comment: "",
          orderType: Belt_Option.getWithDefault(match[9], /* NOTSET */16),
          customerDiscount: Belt_Option.mapWithDefault(match[10], "", (function (x) {
                  return String(x);
                })),
          easyPack: Belt_Option.getWithDefault(match[11], ""),
          shortCustomerName: Belt_Option.getWithDefault(match[12], ""),
          customerFirstName: Belt_Option.getWithDefault(match[13], ""),
          parcStartDate: Belt_Option.mapWithDefault(match[14], order.body.resultCalcPARCStartDate, (function (x) {
                  return Caml_option.some(x);
                })),
          parcEndDate: match[15],
          orderDate: match[16],
          renaultInvoiceDate: match[17],
          carSaleAvailibilityDateMADA: match[18],
          carSaleAvailibilityDateMADC: match[19]
        };
}

function fillFormVehicle(order, newestUndeployedCorrection) {
  var match = Belt_Option.mapWithDefault(newestUndeployedCorrection, Belt_Option.mapWithDefault(order.usedCar, [
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
          ], (function (x) {
              return [
                      x.ucPoliceNumber,
                      x.orderUCLastRegistrationDate,
                      x.orderUcRegistrationId,
                      x.orderUCFirstReleaseDate,
                      x.orderUcBrand,
                      x.orderUcModel,
                      x.orderUcVersion,
                      x.orderUcVin,
                      x.orderRealTradeAmount,
                      x.orderEstimatedTradeAmount,
                      x.orderScrapyardIndicator,
                      order.header.orderOrderType
                    ];
            })), (function (x) {
          return [
                  x.usedCarPoliceNumber,
                  x.usedCarLastRegistrationDate,
                  x.usedCarRegistrationID,
                  x.usedCarFirstReleaseDate,
                  x.brandUsedCar,
                  x.modelUsedCar,
                  x.versionUsedCar,
                  x.vinUsedCar,
                  x.realTradeAmount,
                  x.estimatedTradeAmount,
                  x.scrapyardIndicator,
                  x.orderType
                ];
        }));
  return {
          orderType: Belt_Option.getWithDefault(match[11], /* NOTSET */16),
          policeNumber: Belt_Option.getWithDefault(match[0], ""),
          usedCarLastRegistrationDate: match[1],
          usedCarRegistrationID: Belt_Option.getWithDefault(match[2], ""),
          usedCarFirstReleaseDate: match[3],
          brand: Belt_Option.getWithDefault(match[4], ""),
          model: Belt_Option.getWithDefault(match[5], ""),
          version: Belt_Option.getWithDefault(match[6], ""),
          vin: Belt_Option.getWithDefault(match[7], ""),
          valueUsedCar: Belt_Option.mapWithDefault(match[8], "", (function (x) {
                  return String(x);
                })),
          estimatedValueUsedCar: Belt_Option.mapWithDefault(match[9], "", (function (x) {
                  return String(x);
                })),
          endOfLifeUsedCar: Belt_Option.mapWithDefault(match[10], "", (function (x) {
                  if (x) {
                    return "true";
                  } else {
                    return "false";
                  }
                }))
        };
}

function fillFormAdditional(order, newestUndeployedCorrection) {
  var match = Belt_Option.mapWithDefault(newestUndeployedCorrection, [
        order.body.orderModelId,
        order.body.orderVersionId,
        order.body.orderPhase,
        order.body.orderSalesmanName,
        order.body.orderAgentCode,
        order.body.orderAttributionVehicleDate
      ], (function (x) {
          return [
                  x.modelID,
                  x.versionID,
                  x.phase,
                  x.salesmanName,
                  x.agentCode,
                  x.attributionVehicleDate
                ];
        }));
  return {
          modelID: Belt_Option.getWithDefault(match[0], ""),
          versionID: Belt_Option.getWithDefault(match[1], ""),
          phase: Belt_Option.getWithDefault(match[2], ""),
          salesmanName: Belt_Option.getWithDefault(match[3], ""),
          agentCode: Belt_Option.getWithDefault(match[4], ""),
          attributionVehicleDate: match[5]
        };
}

function shouldShowVO(order, newestUndeployedCorrection) {
  var undeployed = Belt_Option.mapWithDefault(newestUndeployedCorrection, false, (function (x) {
          if (Belt_Option.getWithDefault(x.usedCarPoliceNumber, "").length > 0 || Belt_Option.getWithDefault(x.usedCarRegistrationID, "").length > 0 || Belt_Option.mapWithDefault(x.usedCarLastRegistrationDate, false, App_Types_Date$DvmAdminFrontendFr.isValid) || Belt_Option.mapWithDefault(x.usedCarFirstReleaseDate, false, App_Types_Date$DvmAdminFrontendFr.isValid) || Belt_Option.getWithDefault(x.brandUsedCar, "").length > 0 || Belt_Option.getWithDefault(x.modelUsedCar, "").length > 0 || Belt_Option.getWithDefault(x.versionUsedCar, "").length > 0 || Belt_Option.getWithDefault(x.vinUsedCar, "").length > 0) {
            return true;
          }
          var match = Belt_Option.getWithDefault(order.header.orderOrderType, /* NOTSET */16);
          if (!(match > 15 || match < 1) && match !== 11) {
            if (Belt_Option.mapWithDefault(x.realTradeAmount, false, (function (x) {
                      return x > 0.0;
                    })) || Belt_Option.mapWithDefault(x.estimatedTradeAmount, false, (function (x) {
                      return x > 0.0;
                    }))) {
              return true;
            } else {
              return Belt_Option.getWithDefault(x.scrapyardIndicator, false);
            }
          } else {
            return false;
          }
        }));
  if (Belt_Option.isSome(order.usedCar)) {
    return true;
  } else {
    return undeployed;
  }
}

var correctionOrderTypes = Belt_List.map({
      hd: "SO",
      tl: {
        hd: "CL",
        tl: {
          hd: "VD",
          tl: {
            hd: "VE",
            tl: {
              hd: "RR",
              tl: {
                hd: "RC",
                tl: {
                  hd: "AD",
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    }, (function (x) {
        return {
                label: {
                  TAG: /* String */3,
                  _0: x
                },
                value: x
              };
      }));

var Form;

var FormPerfs;

var FormVehicle;

var FormAdditional;

export {
  Form ,
  FormPerfs ,
  FormVehicle ,
  FormAdditional ,
  nonfleetPARCDatesEditable ,
  orderDeliveredForSevenDays ,
  fillForm ,
  fillFormVehicle ,
  fillFormAdditional ,
  shouldShowVO ,
  correctionOrderTypes ,
}
/* correctionOrderTypes Not a pure module */
